import { useEffect, useState } from "react";

// Bootstrap modal (jQuery global dari public/index.html), pola yang sama dengan
// ModalDesaForm. `openCount` dipakai sebagai `key` agar form di dalam modal
// ter-reset setiap kali dibuka.
const useBootstrapModal = (id) => {
  const [modal, setModal] = useState({ mode: "add", item: null, openCount: 0 });

  useEffect(() => {
    if (modal.openCount) window.$(`#${id}`).modal("show");
  }, [id, modal.openCount]);

  // Tutup modal bila halaman ditinggalkan saat modal masih terbuka (backdrop tidak tertinggal).
  useEffect(
    () => () => {
      window.$(`#${id}`).modal("hide");
      window.$(".modal-backdrop").remove();
      window.$("body").removeClass("modal-open");
    },
    [id]
  );

  return {
    modal,
    open: (mode, item = null) => setModal((prev) => ({ mode, item, openCount: prev.openCount + 1 })),
    setMode: (mode) => setModal((prev) => ({ ...prev, mode })),
    close: () => window.$(`#${id}`).modal("hide"),
  };
};

export default useBootstrapModal;
